export default __webpack_public_path__ + "static/media/BSTExp.6361796a.md";